import { render, staticRenderFns } from "./NewPartners.vue?vue&type=template&id=7a7a4bd0&"
import script from "./NewPartners.vue?vue&type=script&lang=js&"
export * from "./NewPartners.vue?vue&type=script&lang=js&"
import style0 from "./NewPartners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports